import { useFakedUID } from "./useFakeUID";
import useFirebaseData from "./useFirebaseData";
import type { Project } from "../types";

const useFirebaseProject = (project_id: string) => {
  const uid = useFakedUID();
  return useFirebaseData<Project>(uid && project_id ? `/userdata/${uid}/projects/${project_id}` : null);
};

export default useFirebaseProject;
